import { render, staticRenderFns } from "./wtPromptTemplateNameInput.component.vue?vue&type=template&id=70049e64&scoped=true&"
import script from "./wtPromptTemplateNameInput.component.vue?vue&type=script&lang=js&"
export * from "./wtPromptTemplateNameInput.component.vue?vue&type=script&lang=js&"
import style0 from "./wtPromptTemplateNameInput.component.vue?vue&type=style&index=0&id=70049e64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70049e64",
  null
  
)

export default component.exports